import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NzShareModule } from '../../nz/nz-share.module';
import { UIInputComponent } from "./ui-input.component";
import {UIIconModule} from "../ui-icon/ui-icon.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextMaskModule,
    NzShareModule,
    UIIconModule,
  ],
    declarations: [UIInputComponent],
    exports: [UIInputComponent],
})
export class UIInputModule {}
